import { types, Instance } from 'mobx-state-tree';
import { SettingModel } from './setting.model';

const { model, identifier, array, string, maybeNull, number } = types;

export const SettingsGroupModel = model('SettingsGroupModel', {
  name: identifier,
  settings: array(SettingModel),
});
export type ISettingsGroupModel = Instance<typeof SettingsGroupModel>;

export const EndUserKeyModel = model('EndUserKeyModel', {
  id: maybeNull(types.union(number, string)),
  created_at: maybeNull(string),
  client_id: maybeNull(string),
  name: maybeNull(string),
  expires_at: maybeNull(string),
  expiry_date: maybeNull(string),
  client_secret: maybeNull(string),
  grant_types: maybeNull(string),
});

export type IEndUserKeyModel = Instance<typeof EndUserKeyModel>;

export const EndUserSettingModel = model('EndUserSettingModel', {
  companyLogo: maybeNull(string),
  bannerImage: maybeNull(string),
  title: maybeNull(string),
  description: maybeNull(string),
  startDate: maybeNull(string),
  endDate: maybeNull(string),
  companyName: maybeNull(string),
  companyUrl: maybeNull(string),
  helpUrl: maybeNull(string),
  contactUrl: maybeNull(string),
  homeUrl: maybeNull(string),
  domain: maybeNull(string),
  privacyPolicy: maybeNull(string),
  termOfUse: maybeNull(string),
  userId: maybeNull(string),
  googleLogin: maybeNull(string),
  googleAuthentication: maybeNull(string),
  userRequest: maybeNull(string),
  profileSelfUpdate: maybeNull(string),
});
export type IEndUserSettingModel = Instance<typeof EndUserSettingModel>;

export const AttributeModel = model('AttributeModel', {
  label: string,
  type: string,
  name: maybeNull(string),
  options: array(string),
  value: maybeNull(string),
});
export type IAttributeModel = Instance<typeof AttributeModel>;
